import { useEffect, useState } from 'react';
import { useOrganization } from '../contexts/OrganizationContext';
import { teamCostService } from '../services/teamCostService';

// Pergunta ao banco (am_i_org_admin), a mesma regra que a RLS usa.
// Em erro, assume que não é admin.
export function useIsOrgAdmin(): { isAdmin: boolean; loading: boolean } {
  const { organizationId } = useOrganization();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    if (!organizationId) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    teamCostService
      .amIOrgAdmin(organizationId)
      .then((v) => { if (!cancelled) setIsAdmin(v); })
      .catch(() => { if (!cancelled) setIsAdmin(false); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [organizationId]);

  return { isAdmin, loading };
}
